import { useMemo } from 'react';
import cookies from 'browser-cookies';
import { getApiEnvironment, getRegionName, getService, useIsFeatureEnabled, } from '../utils';
import { useSelectSettings, useSelectUserContext } from '../selectors';
import { useGetCurrentApp } from './useGetCurrentApp';
export const useNotificationHubConfig = (applicationId) => {
    const isNotificationsHubEnabled = useIsFeatureEnabled('info-360-notification-hub');
    const { id: userId } = useSelectUserContext();
    const { companySettings: { organization: tenantId }, } = useSelectSettings();
    const product = useGetCurrentApp();
    const notificationHub = useMemo(() => {
        const graphqlEndpointUrl = getService('notificationHub', {}, getApiEnvironment());
        const graphqlRegion = getRegionName();
        const graphqlToken = cookies.get('auth0.user.token') ?? '';
        if (!isNotificationsHubEnabled ||
            !graphqlEndpointUrl ||
            !graphqlRegion ||
            !graphqlToken ||
            !userId ||
            !tenantId ||
            !product) {
            return undefined;
        }
        return {
            graphqlEndpointUrl,
            graphqlRegion,
            graphqlToken,
            userId,
            tenantId,
            product,
            applicationId,
        };
    }, [isNotificationsHubEnabled, tenantId, userId, product]);
    return notificationHub;
};
